import classes from "../../authentication/reusable/TextInput.module.css";
import React from "react";

type Props = { fill?: string };

const EyeSlashIcon = ({ fill = "#3B3F42" }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_13049_103589)">
        <path
          d="M10.7197 0.219727C11.0129 -0.0734454 11.487 -0.0732892 11.7803 0.219727C12.0735 0.512977 12.0735 0.987023 11.7803 1.28027L1.28027 11.7803C1.13403 11.9265 0.941979 12 0.75 12C0.558094 11.9999 0.365905 11.9265 0.219727 11.7803C-0.0732892 11.487 -0.0726955 11.0131 0.219727 10.7207L2.11621 8.82422C0.88102 7.72011 0.15082 6.46375 0.0966797 6.36719C-0.0308081 6.13996 -0.031987 5.86298 0.0947266 5.63574C0.188474 5.467 2.43391 1.50021 6 1.5C6.99813 1.5 7.88645 1.82315 8.66113 2.27832L10.7197 0.219727ZM10.9307 4.25195C11.528 4.97202 11.8679 5.56806 11.9043 5.63379C12.0325 5.86179 12.0316 6.14114 11.9033 6.36914C11.8076 6.53787 9.5299 10.5 6 10.5C5.59305 10.5 5.20476 10.4435 4.83301 10.3506L6.19434 8.98926C8.22737 8.86524 9.7943 6.84744 10.3643 6C10.2421 5.81789 10.0715 5.58025 9.86328 5.32031L10.9307 4.25195ZM6 3C3.85976 3.00019 2.21856 5.12597 1.63574 5.99902C1.91924 6.42127 2.46441 7.13277 3.18066 7.75977L4.55566 6.38379C4.52198 6.26091 4.5 6.13336 4.5 6C4.5001 5.17143 5.17144 4.50015 6 4.5C6.1335 4.5 6.26177 4.52191 6.38477 4.55566L7.55859 3.38086C7.07792 3.15069 6.55639 3 6 3Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};

export default EyeSlashIcon;
